import { render, staticRenderFns } from "./ProjectAgreements.vue?vue&type=template&id=64e77286&"
import script from "./ProjectAgreements.vue?vue&type=script&lang=js&"
export * from "./ProjectAgreements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports